/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Components_Ask_Questions_Label_Answers_SentInputs */

const es_components_ask_questions_label_answers_sent = /** @type {(inputs: Components_Ask_Questions_Label_Answers_SentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Respuestas enviadas`)
};

const en_components_ask_questions_label_answers_sent = /** @type {(inputs: Components_Ask_Questions_Label_Answers_SentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Answers sent`)
};

/**
* | output |
* | --- |
* | "Answers sent" |
*
* @param {Components_Ask_Questions_Label_Answers_SentInputs} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {LocalizedString}
*/
const components_ask_questions_label_answers_sent = /** @type {((inputs?: Components_Ask_Questions_Label_Answers_SentInputs, options?: { locale?: "es" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Components_Ask_Questions_Label_Answers_SentInputs, { locale?: "es" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_components_ask_questions_label_answers_sent(inputs)
	return en_components_ask_questions_label_answers_sent(inputs)
});
export { components_ask_questions_label_answers_sent as "components.ask_questions.label.answers_sent" }